/**
 * Gestión del tab de selección de productos
 * Archivo: product-selection-tab.js
 * Versión: 8 - 2026-02-09 23:55 - Producción (reconstruido)
 */

// Encapsular todo en IIFE para evitar colisiones con configuration-tab.js
(function() {
    'use strict';

// Variables locales para el tab de selección
let selectedProducts = [];

// Funciones principales
function initializeProductSelection() {
    loadStoredProducts();
    setupProductCheckboxes();
    setupContinueButton();
    setupModal();
}

// Cargar productos guardados del localStorage
function loadStoredProducts() {
    try {
        const stored = localStorage.getItem('selectedProducts');
        if (stored) {
            selectedProducts = JSON.parse(stored);
            restoreSelectedCheckboxes();
        }
    } catch (error) {
        console.error('[Product Selection] Error loading stored products:', error);
        localStorage.removeItem('selectedProducts');
    }
}

// Restaurar checkboxes seleccionados
function restoreSelectedCheckboxes() {
    selectedProducts.forEach(function (product) {
        const checkbox = document.querySelector('#product-' + product.product_id);
        if (checkbox) {
            checkbox.checked = true;
        }
    });
}

// Configurar checkboxes de productos
function setupProductCheckboxes() {
    const checkboxes = document.querySelectorAll('.prod-check input[type="checkbox"]');

    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            handleProductSelection(checkbox);
        });
    });
}

// Manejar selección/deselección de producto
function handleProductSelection(checkbox) {
    const productData = extractProductData(checkbox);

    if (!productData) {
        console.warn('[Product Selection] No se pudieron extraer los datos del producto');
        return;
    }

    if (checkbox.checked) {
        addProduct(productData);
    } else {
        removeProduct(productData.product_id);
    }

    updateProductCount();
}

// Extraer datos del producto del DOM
function extractProductData(checkbox) {
    try {
        const productId = checkbox.getAttribute('data-product-id');
        const productElement = document.querySelector('#product-element-' + productId);

        if (!productElement) {
            throw new Error('Elemento del producto no encontrado: ' + productId);
        }

        const metafields = window.productsMetafields ? window.productsMetafields[parseInt(productId)] || [] : [];
        const optionsElement = document.querySelector('#product-options-' + productId);
        const imageElement = productElement.querySelector('img');

        return {
            product_id: productId,
            title: checkbox.getAttribute('data-product-title'),
            min_price: checkbox.getAttribute('data-minum-price'),
            max_price: checkbox.getAttribute('data-maximum-price'),
            metafields: processMetafields(metafields),
            options: parseOptions(optionsElement ? optionsElement.textContent : '[]'),
            image_url: normalizeImageUrl(imageElement ? imageElement.getAttribute('src') : '')
        };
    } catch (error) {
        console.error('[Product Selection] Error extrayendo datos del producto:', error);
        return null;
    }
}

// Procesar metafields
function processMetafields(metafields) {
    if (!Array.isArray(metafields)) return [];

    return metafields.map(function (item) {
        // Manejar metaobjetos con referencias
        if (Array.isArray(item.value) && item.value.length > 0 &&
            typeof item.value[0] === 'object' && item.value[0].hasOwnProperty('item')) {
            return {
                key: item.key,
                value: item.value.map(function (subItem) {
                    return subItem.item;
                })
            };
        }
        return item;
    });
}

// Parsear opciones de producto
function parseOptions(optionsText) {
    try {
        return optionsText ? JSON.parse(optionsText) : [];
    } catch (error) {
        console.warn('[Product Selection] Error parsing product options:', error);
        return [];
    }
}

// Normalizar URL de imagen
function normalizeImageUrl(imageSrc) {
    if (!imageSrc) return '';

    const shopURL = window.SHOP_URL || '';
    try {
        const url = new URL(shopURL);
        return imageSrc.includes(url.hostname) ? 'https:' + imageSrc : shopURL + imageSrc;
    } catch (error) {
        console.warn('[Product Selection] Error normalizing image URL:', error);
        return imageSrc;
    }
}

// Agregar producto a la selección
function addProduct(productData) {
    // Evitar duplicados
    if (!selectedProducts.find(function (p) { return p.product_id === productData.product_id; })) {
        selectedProducts.push(productData);
        saveProducts();
    }
}

// Remover producto de la selección
function removeProduct(productId) {
    selectedProducts = selectedProducts.filter(function (p) {
        return p.product_id !== productId;
    });
    saveProducts();
}

// Guardar productos en localStorage
function saveProducts() {
    try {
        localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
    } catch (error) {
        console.error('[Product Selection] Error saving products:', error);
    }
}

// Actualizar contador de productos
function updateProductCount() {
    // Aquí se puede agregar lógica para mostrar contador visual
}

// Configurar botón continuar
function setupContinueButton() {
    const continueButton = document.querySelector('#continue-products');
    
    if (!continueButton) {
        console.error('[Product Selection] Botón continue-products no encontrado');
        return;
    }

    // Remover cualquier href o onclick previo
    continueButton.removeAttribute('onclick');
    continueButton.setAttribute('href', 'javascript:void(0);');
    continueButton.setAttribute('data-listener-attached', 'true');

    // Clonar el elemento para remover todos los event listeners previos
    const newButton = continueButton.cloneNode(true);
    continueButton.parentNode.replaceChild(newButton, continueButton);

    // Usar capturing phase (true) para capturar el evento ANTES
    newButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        handleProductsContinueClick();
        return false;
    }, true);
}

// Manejar click en continuar
function handleProductsContinueClick() {
    const modal = document.querySelector('#comfirm-products');

    if (!modal) {
        console.error('[Product Selection] Modal comfirm-products no encontrado');
        return;
    }

    // Mostrar el modal removiendo la clase que lo oculta
    modal.classList.remove('catalog-modal-wrap');

    if (selectedProducts.length === 0) {
        showNoProductsModal();
        return;
    }

    showConfirmationModal();
}

// Mostrar modal sin productos
function showNoProductsModal() {
    const modalTitle = document.querySelector('#modal-title');
    const modalText = document.querySelector('#modal-text');
    const confirmButton = document.querySelector('#comfirm-products .continue-modal');

    if (modalTitle) modalTitle.textContent = 'No products selected';
    if (modalText) modalText.textContent = 'Please select at least one product to continue';
    if (confirmButton) confirmButton.style.display = 'none';
}

// Mostrar modal de confirmación
function showConfirmationModal() {
    const modalTitle = document.querySelector('#modal-title');
    const modalText = document.querySelector('#modal-text');
    const confirmButton = document.querySelector('#comfirm-products .continue-modal');

    if (modalTitle) modalTitle.textContent = window.MODAL_DEFAULT_TITLE || 'Confirm Selection';
    if (modalText) modalText.textContent = window.MODAL_DEFAULT_TEXT || 'Continue with selected products?';
    if (confirmButton) confirmButton.style.display = 'flex';
}

// Configurar modal
function setupModal() {
    const modal = document.querySelector('#comfirm-products');
    const confirmButton = document.querySelector('#comfirm-products .continue-modal');
    const closeButtons = document.querySelectorAll('.close-modal');

    // Botón confirmar
    if (confirmButton) {
        confirmButton.addEventListener('click', function (event) {
            event.preventDefault();
            saveProducts(); // Asegurar que están guardados
            modal.classList.add('catalog-modal-wrap');

            // Ir al siguiente tab
            const configTab = document.querySelector("[data-w-tab='Catalog Configuration']");
            if (configTab) configTab.click();
        });
    }

    // Botones cerrar
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            modal.classList.add('catalog-modal-wrap');
        });
    });
}

// Función para reinicializar checkboxes (para AJAX)
function reinitializeCheckboxes() {
    const newCheckboxes = document.querySelectorAll('.prod-check input[type="checkbox"]:not([data-initialized])');
    newCheckboxes.forEach(function (checkbox) {
        checkbox.setAttribute('data-initialized', 'true');
        checkbox.addEventListener('change', function () {
            handleProductSelection(checkbox);
        });
    });
    restoreSelectedCheckboxes();
}

// Función global para compatibilidad
function selectCheckboxes() {
    reinitializeCheckboxes();
}

// Observar cambios en el contenedor de productos (para AJAX)
function observeProductContainer() {
    const productContainer = document.getElementById('ProductGridContainer');
    if (productContainer && window.MutationObserver) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    reinitializeCheckboxes();
                    
                    // También reinicializar el botón por si fue reemplazado
                    setTimeout(function() {
                        setupContinueButton();
                    }, 50);
                }
            });
        });

        observer.observe(productContainer, {
            childList: true,
            subtree: true
        });
    }
}

// Observar también el contenedor principal por si se reemplaza completo
function observeMainContent() {
    const mainCollection = document.getElementById('main-collection-filters');
    if (mainCollection && window.MutationObserver) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    setTimeout(function() {
                        setupContinueButton();
                        reinitializeCheckboxes();
                    }, 100);
                }
            });
        });

        observer.observe(mainCollection, {
            childList: true,
            subtree: true
        });
    }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            initializeProductSelection();
            observeProductContainer();
            observeMainContent();
        }, 100);
    });
} else {
    setTimeout(function () {
        initializeProductSelection();
        observeProductContainer();
        observeMainContent();
    }, 100);
}

// Exportar funciones para uso externo
window.ProductSelectionTab = {
    initialize: initializeProductSelection,
    reinitializeCheckboxes: reinitializeCheckboxes,
    setupButton: setupContinueButton,
    getSelectedProducts: function () { return selectedProducts; },
    clearSelection: function () {
        selectedProducts = [];
        saveProducts();
    }
};

})(); // Fin del IIFE
